import api from "@/api";

//诊断报告列表
export const equipmentTree = (data) => {
    return api.axss("post", `/ocm-oil-site/diagnostic-report/page`,data)
  }
  
//新增
export const addpmentTree = (data) => {
  return api.axss("post", `/ocm-oil-site/diagnostic-report/add`,data)
}

//删除
export const delpmentTree = (id) => {
  return api.axss("get", `/ocm-oil-site/diagnostic-report/del?reportId=${id}`)
}

//已读
export const reportread = (id) => {
  return api.axss("get", `/ocm-oil-site/diagnostic-report/read?id=${id}`)
}

//上传诊断报告
export const diagnosticreport = (id) => {
  return api.axss("get", `/ocm-oil-site/diagnostic-report/upload?id=${id}`)
}

//请求诊断报告详情
export const diagnosticdetail = (reportId) => {
  return api.axss("get", `/ocm-oil-site/diagnostic-report/detail?reportId=${reportId}&type=web`)
}

//编辑
export const diagnosticedit = (data) => {
  return api.axss("post", `/ocm-oil-site/diagnostic-report/edit/up`,data)
}


//设备
export const ocmadminselect = (data) => {
  return api.axss("post", `/ocm-admin/select`,data)
}

// /oil-site/oilSiteModelVOList?oilSiteId=hZgvkGjeciDWSedEFa0sgqo700 

//设备
export const oilSiteModelVOLists = (oilSiteId) => {
  return api.axss("get", `/ocm-oil-site/oil-site/oilSiteModelVOList?oilSiteId=${oilSiteId}`)
}


//设备
export const oilSiteModelPublish = (id) => {
  return api.axss("get", `/ocm-oil-site/diagnostic-report/publish?id=${id}`)
}



export const oilSiteModelread = (id) => {
  return api.axss("get", `/ocm-oil-site/diagnostic-report/read?id=${id}`)
}



export const unreadNumber = () => {
  return api.axss("get", `/ocm-oil-site/diagnostic-report/unread/number`)
}


export const reportname = (id,name) => {
  return api.axss("post", `/ocm-oil-site/diagnostic-report/edit/reportname`,{name,id})
}

export const diagnosticcancel = (reportId) => {
  return api.axss("get", `/ocm-oil-site/diagnostic-report/cancel?reportId=${reportId}`,)
}